<template>
  <div class="tasks">
    <div v-if="loading" style="height: 100%">
      <div class="spinner">
        <scale-loader />
      </div>
    </div>
    <div class="task_list" v-else>
      <div v-if="all_tasks.length < 1">
        <h1 style="text-align: center" >
          {{translate('no_data')}}
        </h1>
      </div>

      <div v-else class="row response_table">
        <table>
          <thead>
          <tr>
            <th scope="col" class="pointer" @click="change_filter('id')" :class="{'selected' : filter_type === 'id'}">
              {{ translate('task.id') }}
              <i class="mdi mdi-arrow-down" :class="{'reverse' : filter_asc === 'asc' && filter_type === 'id'}"></i>
            </th>
            <th scope="col" class="pointer" @click="change_filter('username')" :class="{'selected' : filter_type === 'username'}">
              {{ translate('task.username') }}
              <i class="mdi mdi-arrow-down" :class="{'reverse' : filter_asc === 'asc' && filter_type === 'username'}"></i>
            </th>
            <th scope="col" class="pointer" @click="change_filter('command')" :class="{'selected' : filter_type === 'command'}">
              {{ translate('task.type') }}
              <i class="mdi mdi-arrow-down" :class="{'reverse' : filter_asc === 'asc' && filter_type === 'command'}"></i>
            </th>
            <th scope="col" class="pointer" @click="change_filter('status')" :class="{'selected' : filter_type === 'status'}">
              {{ translate('task.status') }}
              <i class="mdi mdi-arrow-down" :class="{'reverse' : filter_asc === 'asc' && filter_type === 'status'}"></i>
            </th>
            <th scope="col" class="pointer" @click="change_filter('ts')" :class="{'selected' : filter_type === 'ts'}">
              {{ translate('task.ts') }}
              <i class="mdi mdi-arrow-down" :class="{'reverse' : filter_asc === 'asc' && filter_type === 'ts'}"></i>
            </th>
            <th scope="col" class="pointer" @click="change_filter('scheduledTime')" :class="{'selected' : filter_type === 'scheduledTime'}">
              {{ translate('task.ts_scheduled') }}
              <i class="mdi mdi-arrow-down" :class="{'reverse' : filter_asc === 'asc' && filter_type === 'scheduledTime'}"></i>
            </th>
            <th scope="col" class="pointer" @click="change_filter('duration')" :class="{'selected' : filter_type === 'duration'}">
              {{ translate('task.duration') }}
              <i class="mdi mdi-arrow-down" :class="{'reverse' : filter_asc === 'asc' && filter_type === 'duration'}"></i>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="(task,key) in task_list"
              :key="key"
              @click="show_info(task.id)"
              class="pointer"
          >
            <td :data-label="translate('task.id')">
              {{ task.id }}
            </td>
            <td :data-label="translate('task.username')">
              {{ task.username }}
            </td>
            <td :data-label="translate('task.type')">
              {{ task.command }}
            </td>
            <td :data-label="translate('task.status')">
              {{ task.status }}
            </td>
            <td :data-label="translate('task.ts')">
              {{ get_date(task.ts) }}
            </td>
            <td :data-label="translate('task.ts_scheduled')">
              {{ get_date(task.scheduledTime) }}
            </td>
            <td :data-label="translate('task.duration')">
              {{ task.duration }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import TaskModal from "./Modal/Index.vue";

export default {
  name: 'DeviceTasks',
  components: {
    TaskModal
  },
  props: ['dev_fid'],

  computed: {
    task_list () {
      let list = [...this.all_tasks]
      list.sort(this.compareNumbers)
      return list
    },
  },

  data () {
    return {
      all_tasks: [],
      filter_type: 'id',
      filter_asc: 'asc',
      loading: false
    }
  },
  created () {
    this.get_tasks()
  },
  methods:{
    get_tasks(){
      this.loading = true
      this.$http.v1.getDeviceTask(this.dev_fid, (response) => {
        this.loading = false
        this.all_tasks = response.data
        if (Object.keys(this.$route.query).length > 0 && Object.keys(this.$route.query).indexOf("task_id") > -1){
          this.show_info(this.$route.query.task_id)
        }
      })
    },
    show_info(task_id) {
      if (this.$store.getters.getPermissions.permissionGod === true){
        if (!this.$route.query.task_id){
          history.pushState(null, null, window.location.href + '?task_id=' + task_id)
        }
        let t = this.$createElement(TaskModal, {
          props: {
            task_id
          },
          on: {
            close: () => {
              this.$modal.hide('task_modal')
            },
            update: () => {
              this.get_tasks()
              this.$modal.hide('task_modal')
            }
          }
        })
        let temp = { render() { return t } }
        this.$modal.show(temp, {}, {
          height: 'auto',
          adaptive: true,
          clickToClose: true,
          name: 'task_modal'
        })
      }
    },
  }
}

</script>
<style lang="scss" scoped>
.tasks{
  height: 100%;
}

.response_table {
  height: 100%;

  table {
    height: 100%;

    thead {
      height: 50px;
      flex: 0;
      display: inline-block;
    }
    tbody{
      tr{
        &:hover{
          background-color: #eeeeee;
        }
      }
    }

    th {
      i {
        opacity: 0;
        width: 0;
        display: inline-block;
      }

      &.selected {
        color: #000;

        i {
          opacity: 1;
          width: auto;
        }
      }
    }
  }
}

.pointer{
    cursor: pointer;
}

.mdi-arrow-down{
    transform: rotate(0);
    transition: 0.2s;
    &.reverse::before{
        transform: rotate(180deg);
    }
}

</style>
